import { DetalhesSimulacao } from "#/types";
import { request } from "#/utils/request";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

/** Endpoints */
export const ENDPOINT_DETALHE_COTACAO = "/cotacoes/simulada";

/**
 * @function getDetalheCotacao - busca os detalhes de uma cotação específica
 */

type BuscarDetalhesCotacao = {
  numeroCotacao: string;
};

type RouterParams = {
  numeroCotacao: string;
};

async function getDetalheCotacao({ numeroCotacao }: BuscarDetalhesCotacao) {
  const { data } = await request.get<DetalhesSimulacao>(
    `${ENDPOINT_DETALHE_COTACAO}/${numeroCotacao}`
  );

  return data;
}

function useDetalhesCotacao() {
  const { numeroCotacao } = useParams<RouterParams>();

  return useQuery({
    queryKey: ["cotacoesLista", numeroCotacao],
    queryFn: () => getDetalheCotacao({ numeroCotacao }),
    enabled: !!numeroCotacao,
  });
}

export default useDetalhesCotacao;
